/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Work_Order_Publish_FailedInputs */

const en_work_order_publish_failed = /** @type {(inputs: Work_Order_Publish_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`External Work Order Publish Failed. ${i?.message}`)
};

const fr_work_order_publish_failed = /** @type {(inputs: Work_Order_Publish_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Échec de la publication de l’ordre de travail externe. ${i?.message}`)
};

const de_work_order_publish_failed = /** @type {(inputs: Work_Order_Publish_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Veröffentlichung des externen Arbeitsauftrags fehlgeschlagen. ${i?.message}`)
};

const it_work_order_publish_failed = /** @type {(inputs: Work_Order_Publish_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pubblicazione ordine di lavoro esterno non riuscita. ${i?.message}`)
};

const ru_work_order_publish_failed = /** @type {(inputs: Work_Order_Publish_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не удалось опубликовать внешний рабочий заказ. ${i?.message}`)
};

const es_work_order_publish_failed = /** @type {(inputs: Work_Order_Publish_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error en la publicación de la orden de trabajo externa. ${i?.message}`)
};

const zh_cn2_work_order_publish_failed = /** @type {(inputs: Work_Order_Publish_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`外部工单发布失败。${i?.message}`)
};

const ja_work_order_publish_failed = /** @type {(inputs: Work_Order_Publish_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`外部作業指示書の公開に失敗しました。${i?.message}`)
};

const hi_work_order_publish_failed = /** @type {(inputs: Work_Order_Publish_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`बाह्य कार्य आदेश प्रकाशन विफल। ${i?.message}`)
};

const pt_pt2_work_order_publish_failed = /** @type {(inputs: Work_Order_Publish_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Falha na publicação da ordem de serviço externa. ${i?.message}`)
};

/**
* | output |
* | --- |
* | "External Work Order Publish Failed. {message}" |
*
* @param {Work_Order_Publish_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_publish_failed = /** @type {((inputs: Work_Order_Publish_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Publish_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_work_order_publish_failed(inputs)
	if (locale === "de") return de_work_order_publish_failed(inputs)
	if (locale === "it") return it_work_order_publish_failed(inputs)
	if (locale === "ru") return ru_work_order_publish_failed(inputs)
	if (locale === "es") return es_work_order_publish_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_work_order_publish_failed(inputs)
	if (locale === "ja") return ja_work_order_publish_failed(inputs)
	if (locale === "hi") return hi_work_order_publish_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_work_order_publish_failed(inputs)
	return en_work_order_publish_failed(inputs)
});